<template>
    <div class="businessArea">
        <div class="banner_top">
            <img :src="this.sylbAddress" alt="" />
        </div>
        <div class="widthrules">
            <div class="product_box">
                <!-- 菜单 -->
                <div class="product_menu">
                    <div class="product_menu_title">{{ projectMenuTitle }}</div>
                    <div class="product_menu_content">
                        <el-menu
                            class="el-menu-vertical-demo"
                            background-color="#023e7a"
                            text-color="#fff"
                            active-text-color="#ffd04b"
                            ref="elMenu"
                            :default-active="defaultActive"
                            @select="handleSelect_product"
                        >
                            <el-menu-item v-for="(item, idx) in productMenuList" :key="item.menuId" :index="idx.toString()">
                                <span slot="title">{{ item.guideZw }}</span>
                            </el-menu-item>
                        </el-menu>
                        <el-menu
                            class="el-menu-vertical-demo"
                            background-color="#023e7a"
                            text-color="#fff"
                            active-text-color="#ffd04b"
                            ref="elMenu1"
                            :default-active="defaultActive1"
                            @select="handleSelect_operation"
                        >
                            <el-menu-item v-for="(item, idx) in businessDHTreeList" :key="item.menuId" :index="idx.toString()">
                                <span slot="title">{{ item.guideZw }}</span>
                            </el-menu-item>
                        </el-menu>
                    </div>
                </div>
                <!-- 详情 -->
                <div class="product_details">
                    <!-- 书签 -->
                    <div class="product_details_title">
                        <div class="title_more">{{ productMenuActive }}</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right" class="more">
                            <el-breadcrumb-item :to="{ path: '/' }">{{ breadcrumb_item0 }}</el-breadcrumb-item>
                            <!-- <el-breadcrumb-item v-for="(item, index) in $route.matched" :key="index">{{
                                item.meta.title
                            }}</el-breadcrumb-item> -->
                            <!-- <el-breadcrumb-item>{{ breadcrumb_item1 }}</el-breadcrumb-item> -->
                            <el-breadcrumb-item>{{ projectMenuTitle }}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{ productMenuActive }}</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <!-- 产品详情 -->
                    <div class="product_details_content" v-if="showProduct">
                        <div class="content_box" v-for="item in productList" :key="item.productId" @click="showDialog(item.productId)">
                            <div class="content_img">
                                <img class="img" :src="item.backup1" alt="" />
                            </div>
                            <div class="content_title">{{ item.backup }}</div>
                            <!-- <div class="content_brief">{{ item.productBrief }}</div> -->
                        </div>
                        <!-- 产品优势 -->
                        <!-- <div class="product_details_content" v-show="showHtmlText">
                            <div class="ql-container ql-snow">
                                <div class="ql-editor" style="width:890px;">
                                    <div v-html="htmlText"></div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <!-- 产品优势+APP -->
                    <div class="product_details_content" v-else>
                        <div class="ql-container ql-snow">
                            <div class="ql-editor" style="width:890px;">
                                <div v-html="htmlText"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 产品弹窗 -->
                    <el-dialog :title="productContent.backup" :visible.sync="dialogVisible">
                        <div class="ql-container ql-snow">
                            <div class="ql-editor" style="width:890px;">
                                <div v-html="productContent.content"></div>
                            </div>
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
        <!-- <v-footer></v-footer> -->
    </div>
</template>

<script>
// import vFooter from '../common/footer.vue';
import {
    gwGetSYLBList,
    getGWProductInfoList,
    getGWProductInfoListById,
    getGWProductDetailById,
    gwGetBusinessDHTreeList,
    gwGetBusinessContentList,
    gwGetMenuList
} from '@/api/index';
export default {
    name: 'businessArea',
    // components: {
    //     vFooter
    // },
    data() {
        return {
            menuSelect: '',
            menuSelect1: '',
            breadcrumb_item0: '',
            breadcrumb_item1: '',
            sylbAddress: '',
            languageType: '1',
            projectMenuTitle: '',
            productMenuActive: '',
            productMenuList: [],
            productList: [],
            businessDHTreeList: [],
            defaultActive: '0',
            defaultActive1: '',
            htmlText: '',
            showHtmlText: false,
            showProduct: true,
            dialogVisible: false,
            productContent: {}
        };
    },
    watch: {
        $route(to, from) {
            this.showParams();
        }
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        window.addEventListener('setItem', () => {
            if (this.$route.path == '/businessArea/product') {
                this.languageType = sessionStorage.getItem('languageType');
                this.getGWProductInfoList();
                this.gwGetBusinessDHTreeList();
                this.gwGetMenuList();
                if (this.menuSelect) {
                    // 选择了产品
                    this.defaultActive1 = null; // 取消业务领域菜单选中
                } else {
                    this.defaultActive = null;
                }
            }
        });
        this.gwGetSYLBList();
        this.getGWProductInfoList();
        this.gwGetBusinessDHTreeList();
        this.gwGetMenuList();
    },
    mounted() {},
    methods: {
        gwGetMenuList() {
            let params = {
                language: this.languageType
            };
            gwGetMenuList(params).then(res => {
                // console.log('导航加载tree参数必填语言',res.obj)
                this.breadcrumb_item0 = res.obj.menuList[0].guideZw;
                this.breadcrumb_item1 = res.obj.menuList[1].guideZw;
            });
        },
        gwGetSYLBList() {
            let params = {
                language: this.languageType,
                type: '3'
            };
            gwGetSYLBList(params).then(res => {
                this.sylbAddress = res.obj[0].sylbAddress;
            });
        },
        showDialog(id) {
            this.getGWProductDetailById(id);
            this.dialogVisible = true;
        },
        showParams() {
            // if (this.menuSelect) { // 选择产品菜单
            //     this.defaultActive = this.menuSelect;
            //     let keys = this.menuSelect;
            //     this.repeat(keys);
            // } else if (!this.menuSelect1) { // 没选产品菜单，根据跳页id查询
            if (this.$route.query.paramss) {
                // 首页跳过来
                this.defaultActive = String(Number(this.$route.query.paramss));
                let keys = Number(this.$route.query.paramss);
                this.repeat(keys);
            } else if (Number(this.$route.query.params) == 1) {
                // 顶部导航点第一个跳过来
                this.defaultActive = '0';
                let keys = 0;
                this.repeat(keys);
            } else {
                // 顶部导航点其他的跳过来
                this.defaultActive = String(Number(this.$route.query.params) + 1);
                let keys = Number(this.$route.query.params) + 1;
                this.repeat(keys);
            }
            // }
        },
        repeat(keys) {
            // 跳页查询的重复代码
            // console.log('跳页key',keys)
            if (keys == 0) {
                // 展示优势特点
                this.showHtmlText = true;
                // this.gwGetBusinessContentList(16)
            }
            this.productMenuActive = this.productMenuList[keys].guideZw;
            let selected = this.productMenuList[keys].menuId;
            this.getGWProductInfoListById(selected);
        },
        handleSelect_operation(key) {
            this.productMenuActive = this.businessDHTreeList[key].guideZw;
            let selected = this.businessDHTreeList[key].menuId;
            this.menuSelect1 = key;
            this.menuSelect = '';
            // this.defaultActive = ''; // 产品不选中
            this.$refs.elMenu.activeIndex = null; // 取消产品菜单选中
            this.showProduct = false;
            this.gwGetBusinessContentList(selected);
        },
        handleSelect_product(key) {
            this.productMenuActive = this.productMenuList[key].guideZw;
            let selected = this.productMenuList[key].menuId;
            this.menuSelect = key;
            this.menuSelect1 = '';
            // this.defaultActive1 = ''; // 业务领域不选中
            this.$refs.elMenu1.activeIndex = null; // 取消业务领域菜单选中
            this.showProduct = true;
            if (key == 0) {
                this.showHtmlText = true;
                this.gwGetBusinessContentList(16);
            } else {
                this.showHtmlText = false;
            }
            // console.log('我选择的id是',this.menuSelect)
            // console.log('对应的menuId是',selected)
            this.getGWProductInfoListById(selected);
        },
        // 产品导航菜单
        getGWProductInfoList() {
            let params = {
                language: this.languageType
            };
            getGWProductInfoList(params).then(res => {
                // console.log('查询全部产品导航', res.obj);
                this.project_active = res.obj[0].menuId;
                this.projectMenuTitle = res.obj[0].guideZw;
                this.productMenuList = res.obj[0].gList;
                this.productMenuActive = res.obj[0].gList[0].guideZw;
                let menuId = res.obj[0].gList[0].menuId;
                // this.showHtmlText = true;
                // this.gwGetBusinessContentList(16)
                if (this.$route.query.params || this.$route.query.paramss) {
                    this.showParams();
                } else {
                    this.showHtmlText = true;
                    this.gwGetBusinessContentList(16);
                    if (this.menuSelect) {
                        // console.log('走的选择id',this.menuSelect)
                        this.productMenuActive = this.productMenuList[this.menuSelect].guideZw;
                        this.getGWProductInfoListById(this.productMenuList[this.menuSelect].menuId);
                    } else if (!this.menuSelect1) {
                        // 如果没选择业务领域才默认走第一个
                        // console.log('不选择默认第一个',menuId)
                        this.getGWProductInfoListById(menuId);
                    }
                }
            });
        },
        // 产品列表
        getGWProductInfoListById(menuId) {
            let params = {
                language: this.languageType,
                menuId: menuId
            };
            getGWProductInfoListById(params).then(res => {
                // console.log('根据ID查询产品', res.obj);
                this.productList = res.obj;
            });
        },
        // 产品详情
        getGWProductDetailById(id) {
            let params = {
                language: this.languageType,
                productId: id
            };
            getGWProductDetailById(params).then(res => {
                // console.log('根据ID查询产品详情', res.obj);
                this.productContent = res.obj;
            });
        },
        // 业务导航（产品优势+APP）
        gwGetBusinessDHTreeList() {
            let params = {
                language: this.languageType
            };
            gwGetBusinessDHTreeList(params).then(res => {
                // console.log('查询业务导航tree', res.obj);
                let obj1 = res.obj[0].gList[0];
                let obj2 = res.obj[2].gList[0];
                this.businessDHTreeList = [obj2]; // [obj1, obj2]
                // console.log('业务导航选择了的id',this.menuSelect1)
                if (this.menuSelect1) {
                    // console.log('走的选择id',this.menuSelect)
                    this.productMenuActive = this.businessDHTreeList[this.menuSelect1].guideZw;
                    this.gwGetBusinessContentList(this.businessDHTreeList[this.menuSelect1].menuId);
                }
            });
        },
        // 业务列表
        gwGetBusinessContentList(id) {
            let params = {
                language: this.languageType,
                busMenuId: id
            };
            gwGetBusinessContentList(params).then(res => {
                // console.log('查询业务内容根据导航ID与语言类型', res.obj);
                this.htmlText = res.obj.businessA;
            });
        }
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';
@{deep}.el-dialog{width:925px!important;}
.businessArea {
    .el-menu{
        border-right: none;
        // height:680px;
    }
    .el-menu-item{
        text-overflow: ellipsis;  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
        white-space: nowrap;   /* nowrap:规定段落中的文本不进行换行   */
        overflow: hidden;
    }
    // background-color: #eee;
    .banner_top {
        width: 100%;
        margin: auto;
        margin-bottom: -90px;
        img {
            width: 100%;
        }
    }
    .oneBoxs {
        width: 80%;
        margin: auto;
        padding: 80px 100px 0 100px;
        .title {
            width: 200px;
            margin-bottom: 50px;
            .bigTitle {
                text-align: center;
                font-size: 40px;
                font-weight: bold;
            }
            .smallTitle {
                font-size: 16px;
                color: #2f2e2e;
                text-align: center;
            }
        }
    }
    // zhb
.product_box{
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    margin: 0px auto 0px auto;
    padding: 60px 0px 40px 0px;
    overflow: hidden;
    zoom: 1;
    .product_menu{
        width: 220px;
        min-height: 580px;
        background-color: #023e7a;
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
        overflow: hidden;
        zoom: 1;
        .product_menu_title{
            width: 220px;
            color: #fff;
            font-size: 22px;
            line-height:70px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            background: url(https://bj.prova-newenergy.com.cn/profile/upload/tu/icon_3.jpg) no-repeat center top;
            text-align: center;
        }
        .product_menu_content{
            text-align: center;
        }
    }
    .product_details{
        width: 960px;
        // height: 600px;
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 0px;
        background-color: #fff;
        overflow: hidden;
        zoom: 1;
        .product_details_title{
            height: 41px;
            min-height: 41px;
            line-height: 41px;
            .title_more{
                position: relative;
                float: left;
                min-width: 146px;
                padding: 0 5px;
                background: url(https://bj.prova-newenergy.com.cn/profile/upload/tu/icon_1.jpg) repeat-x;
                color: #fff;
                text-align: center;
                font-size: 16px;
                font-weight: 100;
            }
            .title_more::after{
                position: absolute;
                bottom: 0;
                right: -44px;
                width: 44px;
                height: 41px;
                background: url(https://bj.prova-newenergy.com.cn/profile/upload/tu/icon_2.png) no-repeat;
                content: "";
            }
            .more{
                float: right;
                margin-right: 18px;
                line-height: 41px;
                padding-right: 13px;
                // background: url(http://1.krysj.cn/u/Public/Skins/m612/m6121/iFCB_sort_ico3.png) no-repeat right center;
                font-size: 14px;
            }
        }
        .product_details_content{
            padding: 9px;
            box-sizing: border-box;
            min-height: 600px;
            margin-top:10px;
            border: 1px solid #f0f0f0;
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;
            .content_box{
                width: 23.5%; //23.93783%
                position: relative;
                height: fit-content;
                margin: 5px;
                padding: 10px 10px 6px;
                overflow: hidden;
                // transition: all 0.3s ease 0s;
                box-sizing: border-box;
                .content_img{
                    overflow: hidden;
                    height: 200px;
                    .img{
                        width: 100%;
                        height: 100%;
                        transition: all 0.6s ease-in-out;
                        transform: scale(1);
                        object-fit: fill; // contain 保持原有比例；fill 默认 拉伸填充满
                    }
                }
                .content_title,.content_brief{
                    width: auto;
                    margin: 0 0;
                    position: relative;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: center;
                }
                .content_title{
                    margin-top:10px;
                    font-size: 14px;
                    color: #000000;
                    font-weight: bold;
                }
                .content_brief{font-size: 12px;}
            }
            .content_box:hover{
                background: #fafafa;
                box-shadow: 0 0 10px #ddd;
                .img{transform: scale(1.1);}
            }
        }
    }
}
}
</style>
